import React, {useEffect, useMemo} from 'react';
import {Autocomplete, TextField} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {getAnObjectSubSections} from "../../redux/actions/anObjectSubSectionActions";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

/**
 * L2 (подраздел): sectionId + без parentId
 * L3 (подотдел): parentId = id L2
 */
export default function ObjectSubSectionAutocomplete({
  label,
  value,
  sectionId,
  parentId,
  onChange,
  disabled,
  error,
  helperText,
  required,
  fullWidth,
  ...props
}) {
  const dispatch = useDispatch();
  const {anObjectSubSections, anObjectSubSectionRequestedCount} = useSelector((state) => state.anObjectSubSection);
  const isSubSubMode = parentId != null && parentId !== "";

  useEffect(() => {
    if (anObjectSubSectionRequestedCount > 0) return;
    dispatch(getAnObjectSubSections({
      paging: {skip: 0},
      sort: {name: {operator: "asc"}}
    }));
  }, [dispatch, anObjectSubSectionRequestedCount]);

  const filteredOptions = useMemo(() => {
    const list = anObjectSubSections || [];
    if (isSubSubMode) {
      return list.filter(opt => {
        if (opt.id == null) return false;
        return Number(opt.parentId) === Number(parentId);
      });
    }
    if (!sectionId) return [];
    return list.filter(opt => {
      if (opt.id == null) return false;
      if (opt.parentId != null && opt.parentId !== "") return false;
      return Number(opt.sectionId) === Number(sectionId);
    });
  }, [anObjectSubSections, sectionId, parentId, isSubSubMode]);

  const selectedOption = useMemo(() => {
    if (!value) return null;
    return filteredOptions.find(opt => opt.id === value) || null;
  }, [filteredOptions, value]);

  const isDisabled = disabled || (isSubSubMode ? !parentId : !sectionId);

  return (
    <FormControl fullWidth={fullWidth} error={error} required={required} disabled={isDisabled}>
      <Autocomplete
        disabled={isDisabled}
        value={selectedOption}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.id : null);
        }}
        options={filteredOptions}
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        noOptionsText="Нет вариантов"
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            required={required}
            error={error}
          />
        )}
        {...props}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
